var VehicleController = /** @class */ (function () {
    function VehicleController($scope, $state, $element, $ionicScrollDelegate, $mdDialog, $message, $interpolate, $timeout) {
        this.$scope = $scope;
        this.$state = $state;
        this.$element = $element;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.$mdDialog = $mdDialog;
        this.$message = $message;
        this.$interpolate = $interpolate;
        this.$timeout = $timeout;
        this.moved = false;
        this.canDrap = true;
    }
    /**
     * Get scroller
     * @returns {any}
     */
    VehicleController.prototype.getScroller = function () {
        var _this = this;
        return _.find(this.$ionicScrollDelegate['_instances'], function (instance) {
            return instance.$element[0].id === _this.$element.closest('ion-scroll').attr('id');
        });
    };
    /**
     * Go to booking page
     * @param data {IVehicleBooking}
     */
    VehicleController.prototype.gotoBooking = function (data) {
        this.$state.go("internal.editbooking", {
            id: data.Id,
            vehicleBooking: JSON.stringify(data),
            prevState: "internal.addvehiclebooking",
            state: JSON.stringify({
                startDate: this.$scope.vehicle.Availabilities[0].Date,
                scrollTop: this.getScroller().getScrollPosition().top
            })
        });
    };
    /**
     * Show message if user don't have permission to view booking
     * @param date
     */
    VehicleController.prototype.showCannotBookMessage = function (date) {
        var message = this.$message.get('CannotBookOnDate');
        var scope = this.$scope.$new(true);
        scope.date = moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        var html = this.$interpolate(message)(scope);
        this.$message.error(html);
    };
    /**
     * Show error message if user book in the past
     */
    VehicleController.prototype.showCannotBookInThePastMessage = function () {
        this.$message.error('CannotBookInThePass');
    };
    /**
     * click on a day booking
     *
     * Go to booking page if the date don't have any booking
     * Show booking list if the date have 1,2... booking
     *
     * Don't allow book in the past
     * Don't allow book a rest day
     *
     * @param data
     * @param vehicle
     * @param {MouseEvent} $event
     */
    VehicleController.prototype.onDayBookingClicked = function (data, vehicle, $event) {
        var _this = this;
        var events = data.Events;
        var isPast = moment(data.Date, "YYYY-MM-DD").diff(moment(), "days") < 0;
        var dayPlanningEl = $($event.target).closest('.day-booking');
        //Stop if moved
        if (this.moved)
            return;
        //Show booking if have any booking
        if (events.length > 0) {
            dayPlanningEl.addClass('clicked');
            this.$timeout(200).then(function () {
                dayPlanningEl.removeClass('clicked');
                _this.showBookingList(vehicle, data, !isPast);
            });
            return;
        }
        //Show error if booking in the past
        if (isPast) {
            this.showCannotBookInThePastMessage();
            return;
        }
        //Show error message if day is a rest day
        if (!data.Addable) {
            this.showCannotBookMessage(data.Date);
            return;
        }
        //Show add new booking modal
        if (!isPast) {
            var startTime = "00:00";
            if (data.Date === moment().format("YYYY-MM-DD")) {
                startTime = moment().format("HH:mm");
            }
            var event_1 = {
                StartDate: data.Date,
                StartTime: startTime,
                EndDate: data.Date,
                EndTime: "23:59",
                isNew: true,
                Editable: true,
                Owner: true,
                VehicleId: vehicle.VehicleId,
                VehicleName: vehicle.VehicleName,
                VehicleModel: vehicle.VehicleModel
            };
            dayPlanningEl.addClass('clicked');
            this.$timeout(200).then(function () {
                _this.gotoBooking(event_1);
            });
        }
    };
    /**
     * Round date
     * @param {number} number
     * @param {number} sign
     * @returns {number}
     */
    VehicleController.prototype.roundIndex = function (number, sign) {
        if (sign > 0) {
            return Math.floor(number);
        }
        else {
            return Math.ceil(number);
        }
    };
    /**
     * make round a number
     * @param {number} number
     * @param {number} width
     * @param {number} sign
     * @returns {number}
     */
    VehicleController.prototype.roundNumber = function (number, width, sign) {
        var dayIndex = (number / width) * 7;
        dayIndex = this.roundIndex(dayIndex, sign);
        return (dayIndex / 7) * width;
    };
    /**
     * Show booking list
     * @param {IVehicle} vehicle
     * @param dayBooking
     * @param {boolean} addable
     */
    VehicleController.prototype.showBookingList = function (vehicle, dayBooking, addable) {
        this.$mdDialog.show({
            controller: 'BookingsModalController',
            controllerAs: 'vm',
            templateUrl: 'js/internal/vehiclebookings/addvehiclebooking/bookings.modal.html',
            clickOutsideToClose: true,
            escapeToClose: true,
            hasBackdrop: true,
            focusOnOpen: false,
            locals: {
                vehicle: vehicle,
                dayBooking: dayBooking,
                addable: addable,
                scrollTop: this.getScroller().getScrollPosition().top
            }
        });
    };
    /**
     * Get pageX from event
     * @param event
     * @returns {any}
     */
    VehicleController.prototype.getPageX = function (event) {
        return event.gesture.center.pageX;
    };
    /**
     * Determine the user can booking in date range
     * @param {string} startDate
     * @param {string} endDate
     * @returns {any}
     */
    VehicleController.prototype.canBookingInDateRange = function (startDate, endDate) {
        var unavailabilities = this.$scope.vehicle.Unavailabilities;
        var matched = -1;
        var days = moment(endDate, "YYYY-MM-DD").diff(moment(startDate, "YYYY-MM-DD"), "days");
        var _loop_1 = function (i) {
            var currentDate = moment(startDate).add(i, "days").format("YYYY-MM-DD");
            if (moment(startDate).add(i, "days").diff(moment(), "days") < 0) {
                matched = moment(startDate).add(i, "days").format("YYYY-MM-DD");
                return "break";
            }
            _.each(unavailabilities, function (dateUnavailabilitie) {
                if (moment(dateUnavailabilitie, "YYYY-MM-DD").format("YYYY-MM-DD") === currentDate) {
                    matched = currentDate;
                }
            });
        };
        for (var i = 0; i <= days; i++) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
        return matched;
    };
    /**
     * determine can book  in date
     * @param {string} date
     * @returns {boolean}
     */
    VehicleController.prototype.canBookingDate = function (date) {
        return this.canBookingInDateRange(date, date) === -1;
    };
    VehicleController.prototype.safeApply = function (fn) {
        var phase = this.$scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
                fn();
            }
        }
        else {
            this.$scope.$apply(fn);
        }
    };
    VehicleController.prototype.onDragStart = function ($event) {
        var _this = this;
        this.moved = false;
        //Drap to add new timesheet
        var selectionContainer = this.$element.find('.vehicle-days'), helper, pageX, layerXContainer, width, cancel;
        layerXContainer = selectionContainer.offset().left;
        width = selectionContainer.width();
        cancel = false;
        pageX = this.getPageX($event);
        helper = $("<div class='helper'></div>").appendTo(selectionContainer);
        //Cancel if pressed esc key
        $(window).off("keyup.weekTsDayPlanning").on("keyup.weekTsDayPlanning", function (ev) {
            if (ev.keyCode === 27) {
                $(window).off("keyup.weekTsDayPlanning");
                cancel = true;
                helper.remove();
            }
        });
        this.onDragMove = function ($event) {
            //Don't drap if user presses Escape key
            if (cancel)
                return;
            _this.moved = true;
            //Allow drap 2 direction
            var currentPageX = _this.getPageX($event);
            var w = currentPageX - pageX, layerX = pageX - layerXContainer;
            if (w >= 0) {
                var position = {
                    left: _this.roundNumber(layerX, width, 1),
                    right: width - _this.roundNumber(layerX + w, width, -1),
                };
                helper.css(position);
            }
            else {
                var position = {
                    left: _this.roundNumber(currentPageX - layerXContainer, width, 1),
                    right: width - _this.roundNumber(layerX, width, -1)
                };
                helper.css(position);
            }
        };
        this.onDragEnd = function ($event) {
            //Turn off keyup
            $(window).off("keyup.weekTsDayPlanning");
            //Don't drap if user presses Escape key
            if (cancel || !_this.moved) {
                if (helper) {
                    helper.remove();
                }
                return;
            }
            var vehicle = _this.$scope.vehicle;
            var currentPageX = _this.getPageX($event);
            //Start time
            var pageX1 = pageX >= currentPageX ? currentPageX : pageX;
            var startIndex = ((pageX1 - layerXContainer) / width) * 7;
            startIndex = _this.roundIndex(startIndex, 1);
            if (startIndex < 0)
                startIndex = 0;
            var startDate = vehicle.Availabilities[startIndex].Date;
            //End time
            var pageX2 = pageX >= currentPageX ? pageX : currentPageX;
            var endIndex = ((pageX2 - layerXContainer) / width) * 7;
            endIndex = _this.roundIndex(endIndex, 1);
            if (endIndex >= 7)
                endIndex = 7 - 1;
            var endDate = vehicle.Availabilities[endIndex].Date;
            if (startIndex >= endIndex) {
                helper.remove();
            }
            else {
                var unavailability = _this.canBookingInDateRange(startDate, endDate);
                if (unavailability !== -1) {
                    _this.showCannotBookMessage(unavailability);
                    helper.remove();
                    return;
                }
                var startTime = "00:00";
                if (startDate === moment().format("YYYY-MM-DD")) {
                    startTime = moment().format("HH:mm");
                }
                var newItem = {
                    StartDate: startDate,
                    EndDate: endDate,
                    StartTime: startTime,
                    EndTime: "23:59",
                    VehicleId: vehicle.VehicleId,
                    VehicleName: vehicle.VehicleName,
                    VehicleModel: vehicle.VehicleModel
                };
                _this.gotoBooking(newItem);
            }
        };
    };
    VehicleController.prototype.onDrap = function ($event) {
        //Determive date can booking
        if ($event.type === 'dragstart') {
            //Drap to add new timesheet
            var selectionContainer = this.$element.find('.vehicle-days'), pageX = this.getPageX($event), width = selectionContainer.width(), layerXContainer = selectionContainer.offset().left, vehicle = this.$scope.vehicle, startIndex = ((pageX - layerXContainer) / width) * 7;
            startIndex = this.roundIndex(startIndex, 1);
            if (startIndex < 0)
                startIndex = 0;
            var startDate = vehicle.Availabilities[startIndex].Date;
            this.canDrap = this.canBookingDate(startDate);
        }
        if (this.canDrap) {
            if ($event.type === 'dragstart') {
                this.onDragStart($event);
            }
            if ($event.type === 'dragleft' || $event.type === 'dragright') {
                this.getScroller().freezeScroll(true);
                this.onDragMove($event);
            }
            if ($event.type === 'dragend') {
                this.getScroller().freezeScroll(false);
                this.onDragEnd($event);
            }
        }
    };
    VehicleController.prototype.onTouchStart = function () {
        this.moved = false; //Reset moved to default
    };
    VehicleController.$inject = ['$scope', '$state', '$element', '$ionicScrollDelegate', '$mdDialog', '$message', '$interpolate', '$timeout'];
    return VehicleController;
}());
angular.module('shared').directive('vehicle', function () {
    return {
        restrict: 'E',
        controller: VehicleController,
        controllerAs: 'vm',
        templateUrl: 'js/internal/vehiclebookings/directives/vehicle/vehicle.html',
        scope: {
            vehicle: "="
        }
    };
});
